import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
/**
 * @description Creates the 3D_lut layer transformation
 * @memberOf Actions.Adjust
 * @extends SDK.Action
 */

var By3dLutAction = /*#__PURE__*/function (_Action) {
  _inherits(By3dLutAction, _Action);

  var _super = _createSuper(By3dLutAction);

  function By3dLutAction(publicId) {
    var _this;

    _classCallCheck(this, By3dLutAction);

    _this = _super.call(this);
    _this.publicId = publicId;
    return _this;
  }
  /**
   * Returns a string representation of the action
   * @return {string}
   */


  _createClass(By3dLutAction, [{
    key: "toString",
    value: function toString() {
      return "l_lut:".concat(this.publicId, "/fl_layer_apply");
    }
  }]);

  return By3dLutAction;
}(Action);

export { By3dLutAction };